// This file is generated by next-core EcmascriptClientReferenceModule.
import { registerClientReference } from "react-server-dom-turbopack/server";
export const CategoryCreateForm = registerClientReference(
    function() { throw new Error("Attempted to call CategoryCreateForm() from the server but CategoryCreateForm is on the client. It's not possible to invoke a client function from the server, it can only be rendered as a Component or passed to props of a Client Component."); },
    "[project]/src/app/admin/categories/_form.tsx",
    "CategoryCreateForm",
);
export const CategoryRow = registerClientReference(
    function() { throw new Error("Attempted to call CategoryRow() from the server but CategoryRow is on the client. It's not possible to invoke a client function from the server, it can only be rendered as a Component or passed to props of a Client Component."); },
    "[project]/src/app/admin/categories/_form.tsx",
    "CategoryRow",
);
